import { setBooleanFeatureFlagResolver } from '@atlaskit/platform-feature-flags';
import type { FeatureFlagValue, Flags } from '@atlassian/jira-feature-flagging-using-meta';
import type { MockFlags } from '../../common/types';

const isModernFlag = (flagValue: unknown): flagValue is { value: FeatureFlagValue } =>
	flagValue !== null && typeof flagValue === 'object' && 'value' in flagValue;

const legacyFeatureFlagAdapter = (flags: MockFlags) => {
	const modernFeatureFlags: Flags = {};
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Object.entries(flags).forEach(([flagName, flagValue]: [any, any]) => {
		modernFeatureFlags[flagName] = isModernFlag(flagValue) ? flagValue : { value: flagValue };
	});
	return modernFeatureFlags;
};

class MockFeatureFlags {
	// go/jfe-eslint
	static instance: MockFeatureFlags;

	// @ts-expect-error - TS2564 - Property 'mockedFeatureFlags' has no initializer and is not definitely assigned in the constructor.
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	mockedFeatureFlags: Record<any, any> | Flags;

	// go/jfe-eslint
	constructor() {
		if (!MockFeatureFlags.instance) {
			this.mockedFeatureFlags = {};
			setBooleanFeatureFlagResolver((flagKey) => this.mockedFeatureFlags[flagKey]?.value === true);
			MockFeatureFlags.instance = this;
		}
		return MockFeatureFlags.instance;
	}

	getFeatureFlags() {
		return this.mockedFeatureFlags;
	}

	setFeatureFlags(featureFlags?: Flags) {
		this.mockedFeatureFlags = featureFlags || {};
	}
}

const mockFeatureFlagsInstance: MockFeatureFlags = new MockFeatureFlags();

const restoreFeatureFlags = () => mockFeatureFlagsInstance.setFeatureFlags();
const getMockedFeatureFlags = () => mockFeatureFlagsInstance.getFeatureFlags();
const mockFeatureFlags = (featureFlags?: MockFlags) => {
	const mockedFeatureFlags = featureFlags ? legacyFeatureFlagAdapter(featureFlags) : {};
	mockFeatureFlagsInstance.setFeatureFlags(mockedFeatureFlags);
	return restoreFeatureFlags;
};

export { mockFeatureFlags, restoreFeatureFlags, getMockedFeatureFlags };
